import * as React from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { verifyCorporateNumber } from '../../api/constlink';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

interface VerifyCorporateNumberProps {
  user?: any;
  successBtnMsg: string;
  verifiedCorporateNumber: any;
  onPrev?: (data: any) => void;
  onNext?: (data: any) => void;
  updateCorporateNumber: (data: string) => void;
}

function VerifyCorporateNumber({
  user,
  successBtnMsg,
  onPrev,
  updateCorporateNumber,
}: VerifyCorporateNumberProps) {
  const [form] = Form.useForm();
  const [isValid, setIsValid] = useState<boolean>(false);

  const checkCorporateNumber2 = async (corporateNumber: string) => {
    const regExp = /^\d{3}\d{2}\d{5}$/;

    if (!regExp.test(corporateNumber)) {
      setIsValid(false);
      return Promise.reject(new Error('유효하지 않은 사업자등록번호 입니다.'));
    }

    const result: any = await verifyCorporateNumber({ corporateNumber });
    if (result.duplicated) {
      setIsValid(false);
      return Promise.reject(new Error('이미 가입된 사업자등록번호 입니다.'));
    } else {
      setIsValid(true);
      return Promise.resolve();
    }
  };

  return (
    <>
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={18}>
          <Title level={4}>
            {user.name}님! 사업자등록번호를 인증 해 주세요.
          </Title>
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={isMobile ? 12 : 8}>
          <Form
            form={form}
            name="verifyCorporateNumber"
            layout="inline"
            onFinish={() =>
              verifyCorporateNumber(form.getFieldValue('corporateNumber'))
            }
          >
            <Form.Item
              name="corporateNumber"
              style={{ width: '100%' }}
              rules={[
                {
                  validator: (_, value) => checkCorporateNumber2(value),
                },
              ]}
            >
              <Input placeholder="예) 3493901068" />
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: '20px' }}>
        <Col span={8}>
          <Form.Item>
            <Row justify="center">
              <Button
                htmlType="button"
                type="primary"
                style={{ width: '100%' }}
                onClick={() =>
                  updateCorporateNumber(form.getFieldValue('corporateNumber'))
                }
                disabled={!isValid}
              >
                {successBtnMsg}
              </Button>
            </Row>
          </Form.Item>
        </Col>
      </Row>
      <Row justify="center">
        <Col span={8}>
          <Form.Item>
            <Row justify="center">
              <Button
                htmlType="button"
                style={{ width: '100%' }}
                onClick={onPrev}
              >
                뒤로
              </Button>
            </Row>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default VerifyCorporateNumber;
